export const typeOptions = [
  { id: 'national', name: 'National' },
  { id: 'regional', name: 'Regional' },
  { id: 'observance', name: 'Observance' }
];

export const levelOptions = [
  { id: 'national', name: 'National' },
  { id: 'regional', name: 'Regional' }
];
